import { Control } from 'react-hook-form';
import { FormData } from '../types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

interface PerformanceMetricsSectionProps {
  control: Control<FormData>;
}

export const PerformanceMetricsSection = ({ control }: PerformanceMetricsSectionProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-foreground">Performance & Quality Metrics</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            control={control}
            name="client_retention_rate_1yr"
            render={({ field }) => (
              <FormItem>
                <FormLabel>1-Year Retention Rate (%)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.1" 
                    max="100"
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder="e.g., 95.5"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={control}
            name="client_retention_rate_3yr"
            render={({ field }) => (
              <FormItem>
                <FormLabel>3-Year Retention Rate (%)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.1" 
                    max="100"
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder="e.g., 87.2"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <FormField
            control={control}
            name="customer_satisfaction_score"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Customer Satisfaction (1-10)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.1" 
                    min="1"
                    max="10"
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder="e.g., 8.5"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={control}
            name="nps_score"
            render={({ field }) => (
              <FormItem>
                <FormLabel>NPS Score (-100 to 100)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    min="-100"
                    max="100"
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseInt(e.target.value) : null)}
                    placeholder="e.g., 45"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={control}
            name="compliance_track_record_score"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Compliance Score (1-10)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.1" 
                    min="1"
                    max="10"
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder="e.g., 9.2"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            control={control}
            name="client_growth_rate"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Client Growth Rate (%)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.1" 
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder="e.g., 15.3"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={control}
            name="average_client_save_percentage"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Average Client Savings (%)</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.1" 
                    {...field} 
                    value={field.value || ''} 
                    onChange={(e) => field.onChange(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder="e.g., 12.5"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
};